import React, { useState, useRef, useEffect } from 'react';
import './attestation.css';
import app from './firebase.js';
import { getDatabase, ref, set, onValue, remove } from 'firebase/database';
import html2pdf from 'html2pdf.js';
import { Delete, Download, Eye } from 'react-feather';
import { Modal, Button, ConfigProvider } from 'antd';
import QRCode from 'qrcode';
import logo from "./img/edaplogo.png";

const AccessCredentials = () => {
    const [formData, setFormData] = useState({
        genre: 'Homme',
        noms: '',
        matricule: '',
        filiere: '',
        departement: '',
        classe: '',
        anneeAcademique: '',
        typeAccess: 'Bibliothèque Numérique', // or 'Plateforme d\'Apprentissage'
        documentName: '',
        accessLink: '',
        username: '',
        password: '',
        dateEmission: new Date().toISOString().split('T')[0]
    });

    const [documents, setDocuments] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [sortBy, setSortBy] = useState('date'); // 'date' or 'name'
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const db = getDatabase(app);

    // Load documents from Firebase
    useEffect(() => {
        const documentsRef = ref(db, 'AccessCredentials/UNCR/');
        onValue(documentsRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                const documentArray = Object.keys(data).map((key) => ({
                    id: key,
                    ...data[key],
                }));
                // Sort by creation date, newest first
                documentArray.sort((a, b) => {
                    const dateA = new Date(a.createdAt || 0);
                    const dateB = new Date(b.createdAt || 0);
                    return dateB - dateA;
                });
                setDocuments(documentArray);
            }
        });
    }, [db]);

    // Handle ESC key press to close modal
    useEffect(() => {
        const handleEscKey = (event) => {
            if (event.key === 'Escape' && modalVisible) {
                handleModalClose();
            }
        };

        document.addEventListener('keydown', handleEscKey);
        return () => {
            document.removeEventListener('keydown', handleEscKey);
        };
    }, [modalVisible]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (formData.noms.trim() === '' || formData.matricule.trim() === '') {
            alert('Nom et Matricule sont obligatoires!');
            return;
        }

        // Save to Firebase
        const documentRef = ref(db, `AccessCredentials/UNCR/${formData.matricule}_${Date.now()}`);
        set(documentRef, {
            ...formData,
            createdAt: new Date().toISOString()
        })
            .then(() => {
                console.log('Access credentials saved successfully');
            })
            .catch((error) => {
                console.error('Error saving access credentials: ', error);
            });

        // Reset form
        setFormData({
            genre: 'Femme',
            noms: '',
            matricule: '',
            filiere: '',
            departement: '',
            classe: '',
            anneeAcademique: '',
            typeAccess: 'Bibliothèque Numérique',
            documentName: '',
            accessLink: '',
            username: '',
            password: '',
            dateEmission: new Date().toISOString().split('T')[0]
        });
    };

    const showDocumentModal = (document) => {
        setSelectedDocument(document);
        setModalVisible(true);
    };

    const handleModalClose = () => {
        setModalVisible(false);
        setSelectedDocument(null);
    };

    const handleDeleteDocument = (id) => {
        remove(ref(db, `AccessCredentials/UNCR/${id}`))
            .then(() => {
                console.log('Document deleted successfully');
            })
            .catch((error) => {
                console.error('Error deleting document: ', error);
            });
    };

    const downloadPDF = (docData) => {
        const element = document.getElementById(`access-credentials-${docData.matricule}`);
        
        if (!element) {
            console.error('Document element not found');
            return;
        }
        
        const clone = element.cloneNode(true);
        clone.style.cssText = `
            width: 19cm !important;
            min-height: 20.7cm !important;
            margin: 0 auto !important;
            padding: 2cm !important;
            background-color: white !important;
            font-family: 'Times New Roman', serif !important;
            line-height: 1.4 !important;
            position: relative !important;
            box-sizing: border-box !important;
            overflow: hidden !important;
            page-break-inside: avoid !important;
        `;
        
        const tempContainer = document.createElement('div');
        tempContainer.style.cssText = 'position: fixed; top: -9999px; left: -9999px; z-index: -1; overflow: hidden;';
        tempContainer.appendChild(clone);
        document.body.appendChild(tempContainer);

        const A4_WIDTH_PX = 210 / 25.4 * 96;
        const A4_HEIGHT_PX = 297 / 25.4 * 96;

        const wrapper = document.createElement('div');
        wrapper.style.width = `${A4_WIDTH_PX}px`;
        wrapper.style.height = `${A4_HEIGHT_PX}px`;
        wrapper.style.margin = '0';
        wrapper.style.padding = '0';
        wrapper.style.overflow = 'hidden';
        wrapper.style.background = 'white';
        wrapper.appendChild(clone);
        tempContainer.appendChild(wrapper);

        const contentWidth = clone.scrollWidth;
        const contentHeight = clone.scrollHeight;
        const scale = Math.min(A4_WIDTH_PX / contentWidth, A4_HEIGHT_PX / contentHeight);

        clone.style.transformOrigin = 'top left';
        clone.style.transform = `scale(${scale})`;
        clone.style.position = 'relative';

        const options = {
            margin: 0,
            filename: `${docData.noms.replace(/\s+/g, '_')}_access_credentials.pdf`,
            html2canvas: {
                scale: 2,
                useCORS: true,
                backgroundColor: 'white'
            },
            jsPDF: { format: 'a4', orientation: 'portrait', unit: 'pt' },
            pagebreak: { mode: ['avoid-all'] }
        };

        html2pdf()
            .set(options)
            .from(wrapper)
            .toPdf()
            .get('pdf')
            .then(pdf => {
                while (pdf.internal.getNumberOfPages() > 1) {
                    pdf.deletePage(pdf.internal.getNumberOfPages());
                }
            })
            .save()
            .then(() => {
                document.body.removeChild(tempContainer);
            });
    };

    return (
        <div className="UNCR">
            <div className="attestation-form-container">
                <div style={{ textAlign: 'center' }}>
                    <img src={logo} alt="Logo UNCR" className="attestation-form-logo" />
                    <h2>Formulaire de Coordonnées d'Accès</h2>
                </div>
                <form onSubmit={handleSubmit} className="attestation-form">
                    <div className="attestation-form-group">
                        <select
                            id="genre"
                            name="genre"
                            value={formData.genre}
                            onChange={handleInputChange}
                            required
                        >
                            <option value="Femme">Femme</option>
                            <option value="Homme">Homme</option>
                        </select>
                    </div>

                    <div className="attestation-form-group">
                        <input
                            type="text"
                            id="noms"
                            name="noms"
                            value={formData.noms}
                            onChange={handleInputChange}
                            placeholder={`Noms d${formData.genre === 'Femme' ? 'e la Doctorante' : 'u Doctorant'}`}
                            required
                        />
                    </div>

                    <div className="attestation-form-group">
                        <input
                            type="text"
                            id="matricule"
                            name="matricule"
                            value={formData.matricule}
                            onChange={handleInputChange}
                            placeholder="Matricule"
                            required
                        />
                    </div>

                    <div className="attestation-form-group">
                        <input
                            type="text"
                            id="filiere"
                            name="filiere"
                            value={formData.filiere}
                            onChange={handleInputChange}
                            placeholder="Filière"
                            required
                        />
                    </div>

                    <div className="attestation-form-group">
                        <input
                            type="text"
                            id="departement"
                            name="departement"
                            value={formData.departement}
                            onChange={handleInputChange}
                            placeholder="Département"
                            required
                        />
                    </div>

                    <div className="attestation-form-group">
                        <input
                            type="text"
                            id="classe"
                            name="classe"
                            value={formData.classe}
                            onChange={handleInputChange}
                            placeholder="Classe"
                            required
                        />
                    </div>

                    <div className="attestation-form-group">
                        <input
                            type="text"
                            id="anneeAcademique"
                            name="anneeAcademique"
                            value={formData.anneeAcademique}
                            onChange={handleInputChange}
                            placeholder="Année Académique (Ex: 2024-2025)"
                            required
                        />
                    </div>

                    <div className="attestation-form-group">
                        <select
                            id="typeAccess"
                            name="typeAccess"
                            value={formData.typeAccess}
                            onChange={handleInputChange}
                            required
                        >
                            <option value="Bibliothèque Numérique">Bibliothèque Numérique</option>
                            <option value="Plateforme d'Apprentissage en Ligne">Plateforme d'Apprentissage en Ligne</option>
                        </select>
                    </div>

                    <div className="attestation-form-group">
                        <input
                            type="text"
                            id="documentName"
                            name="documentName"
                            value={formData.documentName}
                            onChange={handleInputChange}
                            placeholder="Nom du document"
                            required
                        />
                    </div>

                    <div className="attestation-form-group">
                        <input
                            type="url"
                            id="accessLink"
                            name="accessLink"
                            value={formData.accessLink}
                            onChange={handleInputChange}
                            placeholder={formData.typeAccess === 'Bibliothèque Numérique' ? 'Lien de la bibliothèque' : 'Lien de la plateforme'}
                            required
                        />
                    </div>

                    <div className="attestation-form-group">
                        <input
                            type="text"
                            id="username"
                            name="username"
                            value={formData.username}
                            onChange={handleInputChange}
                            placeholder="Nom d'utilisateur"
                            required
                        />
                    </div>

                    <div className="attestation-form-group">
                        <input
                            type="text"
                            id="password"
                            name="password"
                            value={formData.password}
                            onChange={handleInputChange}
                            placeholder="Mot de passe"
                            required
                        />
                    </div>

                    <div className="attestation-form-group">
                        <input
                            type="date"
                            id="dateEmission"
                            name="dateEmission"
                            value={formData.dateEmission}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className="attestation-form-group full-width">
                        <button type="submit" className="attestation-generate-btn">
                            Créer le Document
                        </button>
                    </div>
                </form>

                {/* Search Bar */}
                <div className="attestation-search-bar" style={{ 
                    display: 'flex', 
                    gap: '10px',
                    width: '90%',
                    marginBottom: '20px',
                    marginTop: '10px',
                    alignItems: 'center',
                    padding: '15px',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '8px',
                    border: '1px solid #dee2e6'
                }}>
                    <input
                        type="text"
                        placeholder="Rechercher par nom ou matricule..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{
                            flex: 1,
                            padding: '10px 15px',
                            fontSize: '14px',
                            border: '1px solid #ced4da',
                            borderRadius: '6px',
                            outline: 'none',
                            transition: 'border-color 0.3s'
                        }}
                        onFocus={(e) => e.target.style.borderColor = '#28a745'}
                        onBlur={(e) => e.target.style.borderColor = '#ced4da'}
                    />
                    <select
                        value={sortBy}
                        onChange={(e) => setSortBy(e.target.value)}
                        style={{
                            padding: '10px 15px',
                            fontSize: '14px',
                            border: '1px solid #ced4da',
                            borderRadius: '6px',
                            backgroundColor: 'white',
                            cursor: 'pointer',
                            outline: 'none',
                            minWidth: '150px'
                        }}
                    >
                        <option value="date">Trier par date</option>
                        <option value="name">Trier par nom</option>
                    </select>
                </div>

                {/* List of saved documents */}
                <div className="attestation-list">
                    {documents
                        .filter(document => 
                            document.noms?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                            document.matricule?.toLowerCase().includes(searchQuery.toLowerCase())
                        )
                        .sort((a, b) => {
                            if (sortBy === 'date') {
                                const dateA = new Date(a.createdAt || 0);
                                const dateB = new Date(b.createdAt || 0);
                                return dateB - dateA;
                            } else {
                                return (a.noms || '').localeCompare(b.noms || '');
                            }
                        })
                        .map((document) => (
                        <div key={document.id} className="attestation-item">
                            <button
                                className="attestation-toggle"
                                onClick={() => showDocumentModal(document)}
                            >
                                <Eye size={16} style={{ marginRight: '8px' }} />
                                {document.noms} - {document.typeAccess}
                            </button>
                            <button
                                className="delete-btn"
                                onClick={() => handleDeleteDocument(document.id)}
                            >
                                <Delete size={15} />
                            </button>
                        </div>
                    ))}
                </div>

                {/* Modal for document preview */}
                <ConfigProvider>
                    <Modal
                        title={
                            <span style={{ color: 'white' }}>
                                {selectedDocument ? `Aperçu - ${selectedDocument.noms}` : 'Aperçu du Document'}
                            </span>
                        }
                        open={modalVisible}
                        onCancel={handleModalClose}
                        width="95vw"
                        style={{ top: 10 }}
                        className="attestation-modal"
                        centered={false}
                        maskClosable={true}
                        keyboard={true}
                        footer={[
                            <Button
                                key="download"
                                type="primary"
                                icon={<Download size={16} />}
                                onClick={() => selectedDocument && downloadPDF(selectedDocument)}
                                style={{
                                    backgroundColor: '#28a745',
                                    borderColor: '#28a745',
                                    fontWeight: 'bold'
                                }}
                            >
                                Télécharger PDF
                            </Button>,
                            <Button
                                key="close"
                                onClick={handleModalClose}
                                style={{ fontWeight: 'bold' }}
                            >
                                Fermer
                            </Button>
                        ]}
                    >
                        {selectedDocument && (
                            <div className="attestation-modal-content">
                                <AccessCredentialsTemplate formData={selectedDocument} />
                            </div>
                        )}
                    </Modal>
                </ConfigProvider>
            </div>
        </div>
    );
};

const AccessCredentialsTemplate = ({ formData }) => {
    const qrCodeRef = useRef();

    // Helper to format date with month in letters (French)
    const formatDateWithMonthName = (dateStr) => {
        const date = new Date(dateStr);
        const months = [
            "janvier", "février", "mars", "avril", "mai", "juin",
            "juillet", "août", "septembre", "octobre", "novembre", "décembre"
        ];
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
    };

    // Generate QR Code with form data
    useEffect(() => {
        const generateQRCode = async () => {
            const qrData = `COORDONNÉES D'ACCÈS - UNCR
Noms: ${formData.noms}
Genre: ${formData.genre}
Matricule: ${formData.matricule}
Type d'accès: ${formData.typeAccess}
Document: ${formData.documentName}
Lien: ${formData.accessLink}
Nom d'utilisateur: ${formData.username}
Date d'émission: ${formatDateWithMonthName(formData.dateEmission)}
Statut: Document Vérifié
Émis par: UNCR - Académie du Cercle de Réflexion des Nations`;
            try {
                const qrCodeUrl = await QRCode.toDataURL(qrData, {
                    width: 120,
                    margin: 1,
                    color: {
                        dark: '#000000',
                        light: '#FFFFFF'
                    }
                });
                if (qrCodeRef.current) {
                    qrCodeRef.current.src = qrCodeUrl;
                }
            } catch (error) {
                console.error('Error generating QR code:', error);
            }
        };

        if (formData) {
            generateQRCode();
        }
    }, [formData]);

    // Helper to get correct text based on genre
    const getDoctorantText = () => {
        return formData.genre === 'Femme' ? "la Doctorante" : "le Doctorant";
    };

    const getChercheurText = () => {
        return formData.genre === 'Femme' ? "la Chercheuse" : "le Chercheur";
    };

    const getTitle = () => {
        return formData.typeAccess === 'Bibliothèque Numérique' 
            ? "COORDONNÉES D'ACCÈS À LA BIBLIOTHÈQUE NUMÉRIQUE" 
            : "COORDONNÉES D'ACCÈS À LA PLATEFORME D'APPRENTISSAGE EN LIGNE";
    };

    return (
        <div className='UNCR'>
            <div className="attestation-container">
                <div className="attestation-document" id={`access-credentials-${formData.matricule}`}>
                    <style>
                        {`
                        .attestation-document {
                            width: 19cm !important;
                            min-height: 20.7cm !important;
                            margin: 0 auto !important;
                            padding: 2cm !important;
                            background-color: white !important;
                            font-family: 'Times New Roman', serif !important;
                            line-height: 1.4 !important;
                            position: relative !important;
                            box-sizing: border-box !important;
                            overflow: hidden !important;
                        }
                        .attestation-header {
                            text-align: center !important;
                        }
                        .academy-name {
                            color: #28a745 !important;
                            font-size: 20px !important;
                            font-weight: bold !important;
                            margin: 0 0 10px 0 !important;
                        }
                        .university-name {
                            color: #28a745 !important;
                            font-size: 18px !important;
                            font-weight: bold !important;
                            margin: 10px 0 !important;
                        }
                        .address, .contact {
                            font-size: 12.5px !important;
                            color: #333 !important;
                            margin: 5px 0 !important;
                        }
                        .separator {
                            height: 2px !important;
                            background-color: #000 !important;
                            margin: 20px 0 !important;
                            border: none !important;
                        }
                        .title {
                            text-align: center !important;
                            font-size: 18px !important;
                            font-weight: bold !important;
                            color: #000 !important;
                            margin: 20px 0 !important;
                            text-transform: uppercase !important;
                        }
                        .academic-year {
                            text-align: center !important;
                            font-size: 16px !important;
                            font-weight: bold !important;
                        }
                        .document-body {
                            font-size: 12.5px !important;
                            line-height: 1.8 !important;
                        }
                        .introduction, .access-info {
                            margin: 20px 0 !important;
                            text-align: justify !important;
                            font-size: 12.5px !important;
                        }
                        .student-details {
                            margin: 20px 0 !important;
                        }
                        .student-details p {
                            margin: 8px 0 !important;
                            font-size: 12.5px !important;
                        }
                        .signature-section {
                            margin-top: 40px !important;
                        }
                        .date-location {
                            font-size: 12.5px !important;
                        }
                        .director-signature {
                            text-align: left !important;
                            margin-top: 40px !important;
                        }
                        .signatures {
                            display: flex !important;
                            align-items: flex-start !important;
                            gap: 20px !important;
                            margin-top: 20px !important;
                        }
                        .signature-text {
                            display: flex !important;
                            flex-direction: column !important;
                            justify-content: flex-start !important;
                        }
                        .signature-images {
                            display: flex !important;
                            align-items: flex-start !important;
                            gap: 15px !important;
                        }
                        .director-title, .director-name {
                            font-weight: bold !important;
                            font-size: 12.5px !important;
                            margin-bottom: 10px !important;
                        }
                        .signature-img, .stamp-img {
                            max-width: 90px !important;
                            height: auto !important;
                        }
                        .qr-container {
                            position: absolute !important;
                            bottom: 2cm !important;
                            right: 2cm !important;
                            text-align: center !important;
                            background-color: white !important;
                            padding: 10px !important;
                            border: 1px solid #ddd !important;
                            border-radius: 8px !important;
                            box-shadow: 0 2px 4px rgba(0,0,0,0.1) !important;
                        }
                        .qr-code {
                            width: 100px !important;
                            height: 100px !important;
                            border: 2px solid #000 !important;
                            border-radius: 4px !important;
                        }
                        `}
                    </style>
                    <div className="attestation-header">
                        <div className="header-text">
                            <h2 className="academy-name">Académie du Cercle de Réflexion des Nations</h2>
                            <div className="logo-container">
                                <img src={logo} alt="Logo UNCR" className="logo" />
                            </div>
                            <h3 className="university-name">UNCR Université en cotutelle internationale de thèse</h3>
                            <p className="address"><strong>1522, Cleveland Street, Hollywood 33020, Florida, USA</strong></p>
                            <p className="contact"><strong>Web : crn-nations.org; E-mail : contact@crn-nations.org</strong></p>
                        </div>
                    </div>

                    <div className="separator"></div>

                    <div className="attestation-content">
                        <h1 className="title">{getTitle()}</h1>
                        <p className="academic-year">Année Académique: {formData.anneeAcademique}</p>

                        <div className="document-body">
                            <p className="introduction">
                                Le Directeur Général de l'Académie du Cercle de Réflexion des Nations aux États Unis atteste par la présente que {getChercheurText()} dont les détails suivants :
                            </p>

                            <div className="student-details">
                                <p>Noms d{formData.genre === 'Femme' ? 'e la Doctorante' : 'u Doctorant'}: <strong>{formData.noms}</strong></p>
                                <p>Matricule: <strong>{formData.matricule}</strong></p>
                                <p>Filière: <strong>{formData.filiere}</strong></p>
                                <p>Département: <strong>{formData.departement}</strong></p>
                                <p>Classe: <strong>{formData.classe}</strong></p>
                            </div>

                            <div className="student-details">
                                <p>Nom du document: <strong>{formData.documentName}</strong></p>
                                <p>Lien {formData.typeAccess === 'Bibliothèque Numérique' ? 'de la bibliothèque' : 'de la plateforme'}: <strong>{formData.accessLink}</strong></p>
                                <p>Nom d'utilisateur: <strong>{formData.username}</strong></p>
                                <p>Mot de passe: <strong>{formData.password}</strong></p>
                            </div>

                            <div className="signature-section">
                                <p className="date-location">Établi à Hollywood le {formatDateWithMonthName(formData.dateEmission)}</p>
                                <div className="director-signature">
                                    <div className="signatures">
                                        <div className="signature-text">
                                            <p className="director-title">Le Directeur Général</p>
                                            <p className="director-name">Pr NIZEYIMANA Jean Baptiste</p>
                                        </div>
                                        <div className="signature-images">
                                            <img src="/bap_sig.png" alt="Signature" className="signature-img" />
                                            <img src="/Bap_Cache.png" alt="Cachet" className="stamp-img" />
                                        </div>
                                        <div className="qr-container">
                                            <img
                                                ref={qrCodeRef}
                                                alt="QR Code - Vérification Document"
                                                className="qr-code"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccessCredentials;
